// BrowseExplore.js
import { connect } from 'react-redux';
import withRouter from '../component/WithRouter.jsx';

import {
  BROWSE_EXPLORE_CATEGORIES,
  FOLLOWING_PAGE_REQUIREMENT,
} from '../RemoteConfigKeys.js';
import BrowseExplore from '../page/BrowseExplore.jsx';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getModalData from '../selector/getModalData.js';
import fetchFeeds from '../action/fetchFeeds.js';
import { SEARCH_MODAL_ID } from '../resource/searchConstants.js';

const mapStateToProps = state => {
  const isSearchModalOpened = ['opening', 'display'].includes(
    getModalData(state, SEARCH_MODAL_ID, 'status')
  );
  const shouldRenderSearchBar = !isSearchModalOpened;
  return {
    meId: getMeData(state, 'id'),
    shouldRenderSearchBar,
    categories: getRemoteConfigData(state, BROWSE_EXPLORE_CATEGORIES),
    followingCount: getMeData(state, 'following'),
    followingPageRequirement: getRemoteConfigData(
      state,
      FOLLOWING_PAGE_REQUIREMENT
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BrowseExplore)
);
